<template>
  <div class="app-container paper-list">
    <basic-container class = "paper-list-container">
      <avue-crud
        ref="crud"
        :option="tableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        :before-open="handleOpenBefore"
        @refresh-change="getList"
        @current-change="handleCurrentChange"
        @selection-change="selectionChange"
        @size-change="handleSizeChange"
        @row-click="rowClick">
        <template slot="menuLeft">
          <div class="paper-list-filter">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col>
                  <el-input class="paper-list-filter-value" v-model.trim="search.title" 
                    @keyup.enter.native="searchChange" placeholder="试卷名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
                </el-col>
              </el-row>
            </div>
          </div>
        </template>
        <template slot="menuRight">
          <div>
            <el-button type="primary" icon="el-icon-search" circle size="small" @click="searchChange"></el-button>
          </div>
        </template>
        <template slot="radio" slot-scope="{row}">
          <el-radio v-model="selectRow" :label="row.$index">-</el-radio>
        </template>
        <template slot-scope="scope"
          slot="menu">
          <el-button size="mini"
            type="text"
            icon="el-icon-view"
            @click="handleView(scope.row,scope.index)">查看
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { getPaperList } from '@/api/app/paper'
import { mapGetters } from 'vuex'
import { paperTypeOption } from '@/const/crud/app/paper'

export default {
  name: 'paperDialog',
  props: {
    tableOption: {
      type: Array,
    },
    paperPrototypeId: {
      type: String,
    },
  },
  data() {
    return {
      search: {
        current: 1,
        size: 10,
        title: '',
      },
      selectRow: '',
      // 列表页面
      tableData:[],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
      },
      tableLoading: false,
      selectPaper: [],
    }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  activated() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size
      }
      this.tableLoading = true
      if (this.search.title != "" && this.search.title.trim() != "") {
        params.pname = this.search.title
      }
      getPaperList(params).then(response => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total
        if (this.paperPrototypeId) {
          this.selectRow =  this.tableData.findIndex(item => item.id === this.paperPrototypeId)
        }
         this.tableData.forEach(record => {
            record.type = (paperTypeOption.find((v) => (v.value == record.type)) ? paperTypeOption.find((v) => (v.value == record.type)).label :'类型异常');
          })
        this.tableLoading = false
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '获取试卷列表失败',
          type: 'error'
        })
        this.tableLoading = false;
      })
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.search.current = val
      this.getList()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.search.size = val
      this.getList()
    },
    initPage() {
      this.page.currentPage = 1
      this.page.pageSize = this.search.size
      this.search.current = 1
    },
    searchChange() {
      this.initPage()
      this.getList()
    },
    searchReset() {
      this.search.title = '',
      this.searchChange()
    },
    rowClick (row) {
      this.selectRow = row.$index
      this.selectPaper = row
    },
    handleView(row, index) {
      let text = this.$router.resolve({
        path: `/app/exam/paper/show/${row.id}`,
      });
      window.open(text.href, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>

.paper-list {
  &-filter {

    &-value {
      width: 96%!important;
    }

    &-date {
      width: 96%!important;
    }

    &-reset {
      float: right;
      margin-right: 8px;
    }

    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
</style>
